<div class="form-group">
  @if(label()){
  <label class="mb-1" [ngClass]="{ required: isRequired }">{{
    label() | translate
  }}</label>
  }
  <div class="col-12 p-0 m-0 position-relative">
    <input
      appTrim
      [type]="hidePassword ? 'password' : 'text'"
      [placeholder]="placeholder() | translate"
      [disabled]="isDisabled()"
      [required]="isRequired()"
      [value]="value"
      (input)="onInputChange($event)"
      (blur)="onTouched()"
      class="form-control"
      [class.is-invalid]="control?.invalid && control?.touched"
    />
    <img
      (click)="hidePassword = !hidePassword"
      class="position-absolute"
      [src]="
        'assets/svg/' +
        (!hidePassword ? 'show-password.svg' : 'hide-password.svg')
      "
      alt=""
      srcset=""
      [ngClass]="{ 'eye-icon-ar': isArabic, 'eye-icon-en': !isArabic }"
    />
  </div>

  @if(control?.errors?.['required'] && control?.touched){
  <div class="invalid-feedback">
    {{ "input.required" | translate }}
  </div>
  } @if(control?.errors?.['pattern'] && control?.touched){
  <div class="invalid-feedback">
    {{ patternErrorMessage() | translate }}
  </div>
  } @if(control?.errors?.['passwordMismatch'] && control?.touched){
  <div class="invalid-feedback">
    {{ patternErrorMessage() | translate }}
  </div>
  }
</div>
